// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".silhouette-field-wrapper .v-menu__content[data-v-10dcec65]{min-width:100% !important}.tree-item-label[data-v-10dcec65]{font-weight:400}.tree-item-label-wrapper[data-v-10dcec65]{padding:12px 0}", ""]);
// Exports
module.exports = exports;
